module.exports = __webpack_public_path__ + "static/media/cashapp.a8c04898.svg";